var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.25c0 1.24-1.01 2.25-2.25 2.25h-3.5c-.62 0-1.18-.25-1.59-.66C8.25 5.43 8 4.87 8 4.25 8 3.01 9.01 2 10.25 2h3.5c.62 0 1.18.25 1.59.66.41.41.66.97.66 1.59Z",
    fill: "#B2B2B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.83 5.03a2.83 2.83 0 0 0-.77-.45c-.29-.11-.58.12-.64.42-.34 1.71-1.85 3-3.67 3h-3.5c-1 0-1.94-.39-2.65-1.1a3.7 3.7 0 0 1-1.02-1.89c-.06-.3-.36-.54-.65-.42C4.77 5.06 4 6.12 4 8.25V18c0 3 1.79 4 4 4h8c2.21 0 4-1 4-4V8.25c0-1.63-.45-2.63-1.17-3.22ZM8 12.25h4c.41 0 .75.34.75.75s-.34.75-.75.75H8c-.41 0-.75-.34-.75-.75s.34-.75.75-.75Zm8 5.5H8c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75Z",
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContract);
export default __webpack_public_path__ + "static/media/ic_contract.2c6115cad81751a6f58151411ad1f7d0.svg";
export { ForwardRef as ReactComponent };